import { Dropdown } from '@webmotors/eleanor-ui';
import { optionsMenuStyles } from './card-options-menu.styles';
import { MoreVerticalIcon } from './icons';
import { myAdsTestId } from '../../../../utils';
import type { TCardOptionsMenuConfig } from './card-options-menu.types';

const CardOptionsMenu = ({
	adId,
	options,
	disabled = false,
	tone = 'default',
	iconColor,
	'aria-label': ariaLabel = 'Menu de ações'
}: TCardOptionsMenuConfig) => {
	if (disabled) {
		return (
			<span
				className={optionsMenuStyles.triggerDisabledWrapper}
				data-testid={myAdsTestId.cardOptionsMenu(adId)}
			>
				<button
					type="button"
					className={optionsMenuStyles.triggerDisabled}
					aria-label={ariaLabel}
					aria-disabled="true"
					disabled
					data-testid={myAdsTestId.cardOptionsMenuTrigger(adId)}
				>
					<MoreVerticalIcon />
				</button>
			</span>
		);
	}

	const triggerClassName = tone === 'overlay' ? optionsMenuStyles.triggerOverlay : optionsMenuStyles.trigger;
	const triggerStyle = iconColor ? { color: iconColor } : undefined;

	return (
		<Dropdown placement="bottomRight" triggerOn="click" data-testid={myAdsTestId.cardOptionsMenu(adId)}>
			<Dropdown.Trigger>
				<button
					type="button"
					className={triggerClassName}
					style={triggerStyle}
					aria-label={ariaLabel}
					data-testid={myAdsTestId.cardOptionsMenuTrigger(adId)}
				>
					<MoreVerticalIcon />
				</button>
			</Dropdown.Trigger>
			<Dropdown.Content>
				{options.map((opt) => (
					<Dropdown.Item
						key={opt.id}
						onClick={() => opt.onSelect()}
						data-testid={myAdsTestId.cardOptionsItem(opt.id, adId)}
					>
						{opt.icon}
						{opt.label}
					</Dropdown.Item>
				))}
			</Dropdown.Content>
		</Dropdown>
	);
};

CardOptionsMenu.displayName = 'CardOptionsMenu';

export { CardOptionsMenu };
